<template>
	<form-field :label="label" :error="error" :require="require">
		<text-area v-bind="$attrs" />
		<slot name="textprepend"></slot>
	</form-field>
</template>

<script setup>
import FormField from '@/components/Form/Field.vue';
import TextArea from 'primevue/textarea';

defineProps({
	label: String,
	error: Object,
	require: {
		type: Boolean,
		default: false,
	},
});
</script>

<script>
export default {
	name: 'InputTextarea',
}
</script>
